import { RowType } from "../types/RowType";

export { BoundaryRow, BoundaryRowData };

type BoundaryRowData = {
  rowType: RowType;
  y0: number;
  y1: number;
  firstSpanId: string;
  pageIndex: number;
};
class BoundaryRow {
  rowType: RowType;
  y0: number;
  y1: number;
  firstSpanId: string;
  pageIndex: number;

  constructor(data: BoundaryRowData) {
    this.rowType = data.rowType;
    this.y0 = data.y0;
    this.y1 = data.y1;
    this.firstSpanId = data.firstSpanId;
    this.pageIndex = data.pageIndex;
  }

  static getHighlightColorIndexForRow(boundaryRow: BoundaryRow): number {
    return this.getHighlightColorIndexForRowType(boundaryRow.rowType);
  }

  static getHighlightColorIndexForRowType(rowType: RowType): number {
    let rowTypeInt;
    switch (rowType) {
      case "START":
        rowTypeInt = 0;
        break;
      case "SOFTSTOP":
        rowTypeInt = 1;
        break;
      case "HARDSTOP":
        rowTypeInt = 2;
        break;
      default:
        rowTypeInt = -1;
    }

    return rowTypeInt;
  }
}
